import { ReactComponent as SPBIcon } from "../../../assets/icons/payment/spb.svg";
import { ReactComponent as CardIcon } from "../../../assets/icons/payment/card.svg";
import { ReactComponent as DolyamiIcon } from "../../../assets/icons/payment/dolyami.svg";
import { ReactComponent as Splitcon } from "../../../assets/icons/payment/split.svg";

export const paymentIconsMap = {
  dolyami: DolyamiIcon,
  payment_online: CardIcon,
  ysplit: Splitcon,
  sbp: SPBIcon,
};
